<template>
  <div id="app">
    <nav class="navbar navbar-expand navbar-dark merkur-nav-bar mb-3">
      <v-img
          id="header-logo-img"
          src="@/assets/test.png"
          max-height="200"
          max-width="250"
          class="ma-0 pa-0"
          @click="goToHome()"
      />
      <div class="navbar-nav nav-bar-content">
        <li v-if="showLeaderBoard" class="nav-item">
          <router-link to="/leader/own" custom v-slot="{ navigate }">
            <button class="btn-three p-2 m-2" :class="{active: isActive === 'leader'}" @click="navigate" role="link" style="color:white; font-weight: bold;">
              <font-awesome-icon icon="home" style="margin-right:4px"/>
              Team Übersicht
            </button>
          </router-link>
        </li>
        <li v-if="showHostBoard" class="nav-item">
          <router-link to="/host" custom v-slot="{ navigate }">
            <button class="btn-three p-2 m-2" :class="{active: isActive === 'host'}" @click="navigate" role="link" style="color: white; font-weight: bold;">
              Veranstaltungen
            </button>
          </router-link>
        </li>
        <li v-if="showSuperBoard" class="nav-item">
          <router-link to="/super" custom v-slot="{ navigate }">
            <button class="btn-three p-2 m-2" :class="{active: isActive === 'super'}" @click="navigate" role="link" style="color: white; font-weight: bold;">
              Alle Benutzer
            </button>
          </router-link>
        </li>
      </div>
        <v-select
                v-if="showRoot"
                label="Company"
                v-model="this.selectedCompanyRoot"
                item-title="name"
                item-value="id"
                :items=companysRoot
                variant="outlined"
                density="compact"
                class="ml-12 my-2 mr-4"
                style="min-width: 100px; max-width: 300px; color: white; font-size: large; max-height: 40px"
        ></v-select>

        <v-icon v-if="showRoot"
                class="my-3 ml-0" style="color: white" size="x-large" icon="mdi-plus"
                @click="() => TogglePopup('createCompanyTrigger')"></v-icon>

        <v-select
                v-if="this.currentUser && this.currentUser.companyDTOList.length > 1 && !showRoot"
                label="Gruppe"
                v-model="this.selectedCompany"
                item-title="name"
                item-value="id"
                :items=this.currentUser.companyDTOList
                variant="outlined"
                density="compact"
                class="ml-12 my-2 mr-4"
                style="min-width: 100px; max-width: 300px; color: white; font-size: large; max-height: 40px"
        ></v-select>

      <div v-if="!currentUser" class="navbar-nav ml-auto">
        <li class="nav-item">
          <router-link to="/login" custom v-slot="{ navigate }">
            <button class="btn btn-three" @click="navigate" role="link" style="color:white; font-weight: bold">
              <font-awesome-icon icon="sign-in-alt"/>
              Anmelden
            </button>
          </router-link>
        </li>
      </div>

      <div v-if="currentUser" class="navbar-nav ml-auto">
        <li v-if="this.currentUser['roles'].includes('ROLE_HOST')" class="nav-item">
          <router-link to="/settings" custom v-slot="{ navigate }">
            <button class="btn-three p-2 m-2" :class="{active: isActive === 'settings'}" @click="navigate" role="link" style="color:white; font-weight: bold">
              <font-awesome-icon icon="user" style="margin-right:4px"/>
              {{ currentUser.email }}
            </button>
          </router-link>
        </li>
        <li class="nav-item">
          <a class="nav-link">
            <button class="btn btn-three" @click.prevent="logOut" style="color:white; font-weight: bold;">
              <font-awesome-icon icon="sign-out-alt" style="margin-right:4px"/>
              Abmelden
            </button>
          </a>
        </li>
      </div>
    </nav>

    <div>

        <router-view v-if="!popupTriggers.createCompanyTrigger"/>
        <CreateCompany v-if="popupTriggers.createCompanyTrigger" :TogglePopup="() => TogglePopup('createCompanyTrigger')"
                       @updateCompanies="updateCompanies($event)"/>
        <ChangeProfile v-if="popupTriggers.changeProfileTrigger" :TogglePopup="() => TogglePopup('changeProfileTrigger')"
                        :companyID="selectedCompany" :oldValue="oldValue" @resetProfile="resetProfile"/>
      <div class="network-alert">
        <font-awesome-icon v-if="!this.connectionState && this.currentUser"  icon="network-wired" fade size="2xl" style="color: #981b1b;" />
        <v-tooltip
          activator="parent"
        >KEINE LIVE-UPDATES VOM SERVER!! PARALLEL-BETRIEB NICHT MÖGLICH</v-tooltip>
      </div>

    </div>
  </div>
  <Footer class="footerBar"></Footer>
</template>

<script>
import Footer from "@/components/CustomFooter";
import CompanyDataService from "../src/services/company.service";
import CreateCompany from "@/components/Root/CreateCompany.vue";
import {ref} from "vue";
import {mapGetters} from "vuex";
import ChangeProfile from "@/components/ChangeProfile.vue";
import utility from "@/util/utility";
import './assets/style.css';

export default {
  components: {ChangeProfile, CreateCompany, Footer},
  setup() {
    const popupTriggers = ref({
      createCompanyTrigger: false,
      changeProfileTrigger: false,
    });

    const TogglePopup = (trigger) => {
      popupTriggers.value[trigger] = !popupTriggers.value[trigger]
    }

    return {
      popupTriggers,
      TogglePopup
    }
  },
  computed: {
    ...mapGetters('stomp',['connectionState']),
    ...mapGetters('auth', ['currComp']),
    companyID() {
      if(this.currentUser){
        return this.currComp;
      }else{
        return null;
      }
    },
    currentUser() {
      if(this.$store.state.auth.user){
        let user = this.$store.state.auth.user
        return user
      }
      return null;
    },
    showHostBoard() {
      if (this.currentUser && this.currentUser['roles']) {
        return this.currentUser['roles'].includes('ROLE_HOST');
      }
      return false;
    },
    showLeaderBoard() {
      if (this.currentUser && this.currentUser['roles']) {
        return this.currentUser['roles'].includes('ROLE_TEAMLEADER');
      }
      return false;
    },
    showSuperBoard() {
      if (this.currentUser && this.currentUser['roles']) {
        return this.currentUser['roles'].includes('ROLE_SUPER_HOST');
      }
      return false;
    },
    showRoot() {
      if (this.currentUser && this.currentUser['roles']) {
        if(this.currentUser['roles'].includes('ROLE_ROOT')){
          this.getCompaniesRoot()
          return true
        }
      }
      return false;
    }
  },
  watch: {
    currentUser(){
      if(this.currentUser){
        this.connectToServer();
      }
    },
    selectedCompanyRoot() {
      this.$store.dispatch("auth/changeCompanyAction", this.selectedCompanyRoot)
    },
    companyID(){
      if(this.currentUser){
        CompanyDataService.getCompany(this.companyID).then(result => {
          const segList = []
          result.data.companySegment.forEach(seg => segList.push(seg.segmentName));
          result.data.companySegment = segList;
          console.log(result.data)
          this.$store.dispatch("company/saveCompanyAction",result.data)
        }).catch(err => {
          console.log(err)
        })
        this.selectedCompany = this.companyID
      }
    },
    selectedCompany(newValue,oldValue){
      if(oldValue && newValue && this.triggerWatcher && !this.showRoot){
        this.oldValue = oldValue
        this.TogglePopup('changeProfileTrigger')
      }else if(!this.triggerWatcher){
        this.triggerWatcher = true
      }
    },
    '$route.path': {
      handler(newPath) {
        if (newPath.startsWith('/leader')) {
          this.isActive = 'leader';
        }
        if (newPath.startsWith('/host') || newPath.startsWith('/event')) {
          this.isActive = 'host';
        }
        if (newPath.startsWith('/super')) {
          this.isActive = 'super';
        }
        if (newPath.startsWith('/settings')) {
          this.isActive = 'settings';
        }
      },
    }
  },
  methods: {
    async connectToServer(){
      let url = utility.URL_SAVE+utility.URL_BASE+":8080/connect"
      this.$socket.connect(url)
    },
    async logOut() {
      this.$socket.disconnect();
      this.$store.dispatch("stomp/setConnectionStateAction", false);
      this.$store.dispatch('auth/localStoreCleanup');
      await this.$router.push('/login');
      this.$store.dispatch('auth/logout');
      this.$store.dispatch("company/clearCompanyAction");

    },
    goToHome() {
      window.location.href = "/home";
    },
    getCompaniesRoot(){
      CompanyDataService.getCompanies().then(response => {
        this.companysRoot = response.data
        this.selectedCompanyRoot = this.$store.state.auth.user.companyID
      }).catch(err => {
        console.log(err)
      })
    },
    updateCompanies(companies){
      this.companysRoot = companies
      this.selectedCompanyRoot = this.$store.state.auth.user.companyID
    },
    resetProfile(oldValue){
      this.TogglePopup('changeProfileTrigger')
      this.triggerWatcher = false
      this.selectedCompany = oldValue;
    }
  },
  data() {
    return {
      selectedCompany: "",
      companysRoot: [],
      selectedCompanyRoot: "",
      oldValue:"",
      triggerWatcher: true,
      isActive: false,
    }
  },
  mounted() {
    console.log(process.env.VUE_APP_URL_BASE)
    if(this.$socket.socket === null && this.currentUser){
      this.$store.dispatch("stomp/setConnectionStateAction",false)
      console.log("Reconnecting to Server...")
      this.connectToServer()
    }
    if(this.companyID){
      this.selectedCompany = this.companyID
    }
  },
  beforeUnmount() {
    this.$socket.disconnect();
  }
}
</script>

<style scoped>
.merkur-nav-bar {
  background-color: var(--merkur-bg-color);
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

.nav-bar-content {
  margin-left: 10px;
}

li {
  margin: auto;
}

</style>

<style>

div {
  font-family: "Merkur Sans Light";
}

.content-body {
  width: 100%;
  min-height: 600px;
  padding-bottom: 15px;
  margin-bottom: 10px;
  margin-right: 10px;
  margin-left: 10px;
  display: inline-block;
  background-color: var(--container-bg-color);
  border-radius: 10px;
  border-width: 10px;
}

.btn-three {
  color: #FFF;
  position: relative;
}

.active {
  border: 2px solid white;
  border-radius: 5px;
}

.network-alert {
  position: absolute !important;
  right: 50px;
  top: 110px;
}

.v-data-table__td {
  padding-top: 13px !important;
  font-size: 17px;
}

.v-data-table__tr:hover {
  background: aliceblue;
  cursor: default;
}

</style>